import {
    makeHttpRequest,
    mapDatabaseParamsFromServer,
    mapPaginationParamsToServer,
} from "@/shared";

import { mapInventoryPricesFromServer } from "./mappers/mapInventoryPricesFromServer";

export const getInventoryPrices = async (paginationParams = {}) => {
    const response = (
        await makeHttpRequest({
            url: "/inventory/price",
            method: "GET",
            params: mapPaginationParamsToServer(paginationParams),
        })
    ).data;

    return {
        data: mapInventoryPricesFromServer(response.data),
        ...mapDatabaseParamsFromServer(response),
    };
};
